import cls from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import useStyles from './styles';
import ImageWithTextListContainedProps from './types';

function ImageWithTextListContained({
  className,
  title,
  items,
  TitleTag = 'h2',
  ItemTitleTag = 'h3',
  children,
}: ImageWithTextListContainedProps) {
  const classes = useStyles();
  const handleClickImage = (url: string) => {
    if (url) {
      window.location.href = url;
    }
  };
  return (
    <section className={cls(classes.root, className)}>
      <div className={classes.container}>
        <TitleTag className={cls('fs-42', classes.title)}>{title}</TitleTag>
        <ul className={classes.content}>
          {items.map((item, i) => (
            <li className={classes.item} key={`iwtlc-${i}`}>
              <LazyLoadImage
                className={cls(classes.img, { href: item.url })}
                src={item.src}
                alt={item.alt}
                onClick={() => handleClickImage(item.url)}
              />

              <ItemTitleTag className={cls('fs-20', classes.itemTitle)}>{item.title}</ItemTitleTag>
              {item.description && <p className={'fs-16'}>{item.description}</p>}
            </li>
          ))}
        </ul>
      </div>
      {children}
    </section>
  );
}

export default ImageWithTextListContained;
